import React from "react";

function Pagethree() {
  return (
    <div
      style={{
        backgroundColor: "#7BC46F29",
        padding: "60px 20px",
        margin: "40px auto",
        maxWidth: "1400px",
        borderRadius: "20px",
      }}
    >
      {/* Hero Section */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
          marginBottom: "60px",
        }}
      >
        <h1
          style={{
            fontSize: "48px",
            fontWeight: "700",
            marginBottom: "24px",
            color: "#6AB676",
          }}
        >
          Your Business Command Center
        </h1>
        <p
          style={{
            fontSize: "24px",
            lineHeight: "1.6",
            maxWidth: "800px",
            margin: "0 auto",
            color: "#4a4a4a",
          }}
        >
          A Qbicle is a place where you can manage and see everything happening
          in your business. It's a collaborative space for your business
          processes.
        </p>
      </div>

      {/* Features Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "40px",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 0",
        }}
      >
        {/* Feature 1 */}
        <div
          style={{
            padding: "30px",
            backgroundColor: "#f8f9fa",
            borderRadius: "15px",
            transition: "transform 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-10px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <h3
            style={{
              fontSize: "24px",
              marginBottom: "16px",
              color: "#1f3121",
            }}
          >
            Seamless Integration
          </h3>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#4a4a4a",
            }}
          >
            Qbicles works seamlessly with our business tools to make processes
            like purchases more transparent and efficient.
          </p>
        </div>

        {/* Feature 2 */}
        <div
          style={{
            padding: "30px",
            backgroundColor: "#f8f9fa",
            borderRadius: "15px",
            transition: "transform 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-10px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <h3
            style={{
              fontSize: "24px",
              marginBottom: "16px",
              color: "#1f3121",
            }}
          >
            Effortless Efficiency
          </h3>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#4a4a4a",
            }}
          >
            Streamline your business and achieve more with less effort. Simplify
            your workflows and boost productivity.
          </p>
        </div>

        {/* Feature 3 */}
        <div
          style={{
            padding: "30px",
            backgroundColor: "#f8f9fa",
            borderRadius: "15px",
            transition: "transform 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-10px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <h3
            style={{
              fontSize: "24px",
              marginBottom: "16px",
              color: "#1f3121",
            }}
          >
            Reduce Fraud
          </h3>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#4a4a4a",
            }}
          >
            Reduce fraud and increase transparency. Keep your business
            operations secure and visible.
          </p>
        </div>
      </div>

      {/* Call to Action */}
      <div
        style={{
          background: "#6AB676",
          textAlign: "center",
          marginTop: "60px",
          padding: "40px",
          borderRadius: "15px",
          maxWidth: "1000px",
          margin: "60px auto",
        }}
      >
        <h2
          style={{
            color: "#ffffff",
            fontSize: "32px",
            marginBottom: "24px",
          }}
        >
          Spend Better, Grow Faster
        </h2>
        <p
          style={{
            color: "#ffffff",
            fontSize: "18px",
            marginBottom: "32px",
            maxWidth: "600px",
            margin: "0 auto 32px",
          }}
        >
          Catch procurement issues before they happen and optimize your business
          spending.
        </p>
        <button
          style={{
            backgroundColor: "#ffffff",
            color: "#1f3121",
            padding: "16px 32px",
            border: "none",
            borderRadius: "8px",
            fontSize: "18px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            fontWeight: "600",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f0f0f0")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#ffffff")
          }
        >
          Get Started Today
        </button>
      </div>
    </div>
  );
}

export default Pagethree;
